import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardRoutingModule, routedComponents } from './dashboard-routing.module';
import {SearchPanelComponent} from './search-panel/search-panel.component';
import {ResultPanelComponent} from './result-panel/result-panel.component';
import { EmailPanelComponent } from './email-panel/email-panel.component';
import { SavedQueriesPanelComponent } from './saved-queries-panel/saved-queries-panel.component';


@NgModule({
  imports: [
    SharedModule,
    DashboardRoutingModule
  ],
  declarations: [DashboardComponent, routedComponents,
      SearchPanelComponent, ResultPanelComponent, EmailPanelComponent, SavedQueriesPanelComponent,
  ],
  exports: []
})
export class DashboardModule {}
